module.exports = __webpack_public_path__ + "static/media/tel.275b7101.svg";